export default "https://cdn-static.gokick.com/assets/7618e3e921e472ff268b4a806e404f75ad5d1010/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";